import React, { useEffect, useState } from "react";
import ListingCompany from "../CompanySetting/listing";
// import ListingRole from "../RoleSetting/listing";
import ListingUser from "../UserSetting/listing";
import axios from "axios";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import CustomTabPanel from "components/customTabPanel";
import AppBar from "@mui/material/AppBar";
// import UserStepper from "../UserSetting/stepper";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PrivateLayout from "layouts/privateLayout";
import Setting from "pages/Setting";
import CompanyForm from "pages/CompanySetting/form";
// import RoleForm from "pages/RoleSetting/form";
import { Button } from "@mui/material";
import ButtonComponent from "components/button";
import UserSetting from "pages/UserSetting";
import ErrorAlert from "helper/errorAlert";
import { useNavigate } from "react-router-dom";
import { useApiClient } from "context/ApiClientContext";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function FullWidthTabs() {
  const theme = useTheme();
  const [companyId, setCompanyId] = useState();
  const [userId, setUserId] = useState();
  const [value, setValue] = useState(0);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [formData, setFormData] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if a form was submitted
    const isFormSubmitted = localStorage.getItem("isFormSubmitted") === "true";

    if (isFormSubmitted) {
      // Stay on the current tab
      const activeTab = Number(localStorage.getItem("activeTab"));
      setValue(activeTab);
      localStorage.setItem("isFormSubmitted", "false");
    } else {
      // Default to the General Setting tab
      setValue(0);
      localStorage.setItem("activeTab", 0);
    }
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    localStorage.setItem("activeTab", newValue);
    setShowCreateForm(false);
  };
  const apiClient = useApiClient();
  
  const handleShowForm = (id) => {
    setShowCreateForm(!showCreateForm);
    setCompanyId();
    setUserId();
    setFormData();
  };

  const handleShowCompany = (id) => {
    setCompanyId(id);
    axios
      .get(`${apiClient}/company/${id}`,
      {
        headers:{
          Authorization:`Bearer ${localStorage.getItem('token')}`,
        }
      })
      .then((response) => {
        const companyData = response.data;

        setFormData(companyData);
        setValue(1);
        localStorage.setItem("activeTab", 1)
        setShowCreateForm(true);
      })
      .catch((error) => {
        ErrorAlert(error, navigate)
      });
  };

  const handleShowUser = (id) => {
    setUserId(id);
    axios
      .get(`${apiClient}/user/${id}`,
      {
        headers:{
          Authorization:`Bearer ${localStorage.getItem('token')}`,
        }
      })
      .then((response) => {
        const userData = response.data;

        setFormData(userData);
        setValue(2);
        localStorage.setItem("activeTab", 2)
        setShowCreateForm(true);
      })
      .catch((error) => {
        ErrorAlert(error, navigate)
        console.error("Error fetching user details:", error);
      });
  };

  const handleSubmitForm = () => {
    setShowCreateForm(false);
    localStorage.setItem("isFormSubmitted", "true");
  };

  // const handleShowRole = (id) => {
  //   setRoleId(id);
  //   axios
  //     .get(`${process.env.REACT_APP_BASE_URL}/role/${id}`)
  //     .then((response) => {
  //       const roleData = response.data;

  //       setFormData(roleData);
  //       setValue(3);
  //       setShowCreateForm(true);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching user details:", error);
  //     });
  // };

  return (
    <PrivateLayout>
      <Box sx={{ bgcolor: "background.paper" }}>
        <AppBar position="static" sx={{}}>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="blue[700]"
            textColor="inherit"
          >
            <Tab label="General Setting" />
            <Tab label="Company Setting" />
            <Tab label="User Setting " />
            {/* <Tab label="Role Setting" /> */}
          </Tabs>
        </AppBar>

        <CustomTabPanel value={value} index={0} dir={theme.direction}>
          <Setting />
        </CustomTabPanel>

        {/* COMPANY SETTING */}
        <CustomTabPanel value={value} index={1} dir={theme.direction}>
          <Box>
            {showCreateForm ? (
              <React.Fragment>
                <CompanyForm
                  companyData={formData}
                  id={companyId}
                  handleShowForm={handleShowForm}
                  onSubmit={handleSubmitForm}
                />
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Box display="flex" justifyContent="end" alignItems="center" mb={1}>
                  <ButtonComponent
                    value="contained"
                    text="Add company"
                    callback={handleShowForm}
                  />
                </Box>
                <ListingCompany setShowCompany={handleShowCompany} />
              </React.Fragment>
            )}
          </Box>
        </CustomTabPanel>

        {/* USER SETTING */}
        <CustomTabPanel value={value} index={2} dir={theme.direction}>
          <Box>
            {showCreateForm ? (
              <React.Fragment>
                <UserSetting
                  userData={formData}
                  userId={userId}
                  handleShowForm={handleShowForm}
                  onSubmit={handleSubmitForm}
                />
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Box display="flex" justifyContent="end" alignItems="center">
                  <ButtonComponent
                    value="contained"
                    text="Add User"
                    callback={handleShowForm}
                  />
                </Box>
                <ListingUser setShowUser={handleShowUser} />
              </React.Fragment>
            )}
          </Box>
        </CustomTabPanel>

        {/* ROLE SETTING */}
        {/* <CustomTabPanel value={value} index={2} dir={theme.direction}>
        <Box pt={5}>
        {showCreateForm ? (
            <React.Fragment>
              <RoleForm roleData={formData} id={roleId} handleShowForm={handleShowForm} />
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Box display="flex" justifyContent="end" alignItems="center">
                <Button variant="contained" onClick={handleShowForm}>
                  Create New Role
                </Button>
              </Box>
              <ListingRole setShowCompany={handleShowRole} />
            </React.Fragment>
          )}        
          </Box>
          </CustomTabPanel> */}
      </Box>
    </PrivateLayout>
  );
}
